<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('common_words.geo_position_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-4">
        <fg-input
          type="number"
          step="0.01"
          name="common_words.latitude"
          :label="`${$t('common_words.latitude')}: `"
          @change="validateNumber"
          v-model="model.latitude"
          v-validate="{ required: true }"
          :error="getError('common_words.latitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          step="0.01"
          name="common_words.longitude"
          :label="`${$t('common_words.longitude')}: `"
          @change="validateNumber"
          v-model="model.longitude"
          v-validate="{ required: true }"
          :error="getError('common_words.longitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          step="0.01"
          name="common_words.altitude"
          :label="`${$t('common_words.altitude')}: `"
          @change="validateNumber"
          v-model="model.altitude"
          v-validate="{ required: true }"
          :error="getError('common_words.altitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <div
            ref="map"
            class="map"
            v-if="renderComponent"
            style="height: 500px"
          ></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
        alt: 24,
      },
      model: {
        latitude: null,
        longitude: null,
        altitude: null,
      },
      map: null,
      renderComponent: true,

      modelValidations: {
        latitude: {
          required: true,
        },
        longitude: {
          required: true,
        },
        altitude: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinArcgisMap, mixinMasters],
  methods: {
    validateNumber($text) {
      let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
      if ($text.target.value.match(regex) == null) {
        //$text.target.classList.add("custom-has-error");

        switch ($text.target.name) {
          case 'latitud':
            this.model.latitude = null;
            break;

          case 'longitud':
            this.model.longitude = null;
            break;

          case 'altitud':
            this.model.altitude = null;
            break;

          default:
            break;
        }
      } else {
        //$text.target.classList.remove("custom-has-error");
      }
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        this.$emit('fillStationForm', 'secondStep');
        return res;
      });
    },

    geoMap() {
      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;
      this.center.alt = this.model.altitude
        ? parseFloat(this.model.altitude)
        : this.center.alt;

      this.loadMap();
    },

    loadMap() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null, true);

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 11%';
        }, 10);
      });
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillStationForm', 'secondStep');
        return res;
      });
    },
  },

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { latitude, longitude, altitude } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = { ...this.model, latitude, longitude, altitude };
    }

    this.geoMap();
  },
};
</script>
<style></style>
